module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kmDLk"))).then(() => parcelRequire('fThBo'));